function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "es8FCudH32t2"
}, /*#__PURE__*/React.createElement("g", {
  id: "es8FCudH32t3"
}, /*#__PURE__*/React.createElement("path", {
  id: "es8FCudH32t4",
  d: "",
  fill: "none",
  stroke: "rgb(63,87,135)",
  strokeWidth: 1.28
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "es8FCudH32t5",
  d: "M320,240L403.883495,240C438.086301,240,470.355816,238.700092,488.451377,230.105002C522.528387,213.918988,488.06572,198.506348,469.126208,170.097081C450.446309,142.077233,494.105168,98.629201,511.055094,124.730071C525.048538,146.278311,592.099007,113.836952,518.834945,87.249187Q390.420706,40.647245,401.812294,96.569576Q401.812293,131.779933,319.999995,136.957926Q238.187697,142.135919,286.860836,87.249187Q340.711969,31.326857,202.977341,49.967633C65.242713,68.608409,278.576046,442.459541,138.770221,405.177988C-1.035604,367.896435,199.870545,322.330091,240.258894,360.647243Q280.647243,398.964395,372.815528,389.644007Q444.271839,374.110026,444.271839,319.223295C444.271839,293.168013,447.626166,223.22655,412.168279,191.844654C372.932386,157.119045,293.578049,162.481226,272.362454,170.097081Q231.974104,184.595463,228.867308,240Q227.831709,317.152098,319.999994,320.258894Q412.168279,323.36569,383.171515,220.841418Q369.708744,184.595463,320,191.844654Q270.291256,199.093845,270.291256,240Q268.220071,290.226531,320,287.119735Q371.779929,284.012939,363.49514,239.999994Q353.139152,199.803704,319.999994,201.537804Q286.860836,203.271904,286.860836,240",
  transform: "matrix(1 0 0 1 0.000006 0.000006)",
  fill: "none",
  stroke: "rgb(63,87,135)",
  strokeWidth: 1.28
});

function SvgLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "es8FCudH32t1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 640 480",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.861163e3.svg";
export { ForwardRef as ReactComponent };